import { axiosInstance } from '@/http-common'

export function massRemoveSentGeo(sentGeo: Array<any>): Promise<any> {
    return new Promise((resolve, reject) => {
        const ids: Array<any> = []
        for (const i in sentGeo) {
            ids.push(sentGeo[i].id)
        }
        axiosInstance.delete('/api/v1/sentgeo', {
            params: {
                ids: ids
            }
        }).then(response => {
            resolve(response)
        }).catch(response => {
            reject(response)
        })
    })
}
export function massRemoveNotificationsHistory(notificationsHistory: Array<any>): Promise<any> {
    return new Promise((resolve, reject) => {
        const ids: Array<number> = [];

        for (const notification of notificationsHistory) {
            ids.push(notification.notificationHistory.id);
        }

        axiosInstance.delete('/api/v1/notification-history/delete', {
            params: {
                ids: ids
            }
        }).then(response => {
            resolve(response);
        }).catch(response => {
            reject(response);
        });
    });
}

export function massRemoveNotificationsHistoryByCriteria(criteria: any): Promise<any> {
    return axiosInstance
        .delete('/api/v1/notification-history/delete-by-criteria', { data: criteria })
        .then((response) => response)
        .catch((error) => Promise.reject(error));
}

export function removeTachoJob(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.delete(`/api/v1/tacho/remove/${ id }`)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}